export function amendmentUserErrorMessage(raw?: string): string {
  if (!raw) {
    return "This amendment could not be applied. Try applying this change manually.";
  }
  if (
    raw.includes("Could not find text") ||
    raw.includes("Could not find anchor") ||
    raw.includes("Could not find insertion point")
  ) {
    return "The referenced text could not be found in the document. Try applying this change manually.";
  }
  if (
    raw.includes("Invalid insertion") ||
    raw.includes("Invalid insert_inline") ||
    raw.includes("Unknown action type")
  ) {
    return "This amendment appears to be incomplete or invalid. Try applying this change manually.";
  }
  return "This amendment could not be applied. Try applying this change manually.";
}
